import React, {Component, Fragment} from 'react';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { authService } from '../../services/authService';

import {
  Drawer,
  Spin,
  Row, 
  Col,
  Divider,
  Button,
  Input,
} from 'antd';

import { 
  CloseOutlined,
} from '@ant-design/icons';

import InputWithDropdown from '../elements/InputWithDropdown';
import { API_BASE_URL } from '../../config/api';

export default class Addon extends Component {
  constructor(props){
    super(props);
    this.state = {
      visible: props.visible,
      patient: props.addonItem,
      loading: false,

      orderedTests: [],

      orderSets: [],
      addonTests: [],
      loadingTests: false,
      searchByCodeOrName: "",

      submittedBy: "",

      errors: [],
    }
  }

  componentDidMount(){
    this.loadData()
  }

  loadData = async () => {
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }
    axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/accessions/${this.state.patient.accession}`,
      headers: { Authorization: `Bearer ${token}` },
    }).then(res => {
      this.setState({
        orderedTests: res.data.tests,
        loading: false,
      })
    }).catch(err =>{
      console.log(err);
    })
  }

  handleTestSearch = (property, value) => {
    this.setState({
      [property]: value
    }, this.fetchTests)
  };

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  };

  onSelectOrderSet = (test) => {
    let selectedItem = {};
    this.state.orderSets.forEach(item => {
      if (item.id === test.id){
        selectedItem = item
      }
    })
    
    let addons = [...this.state.addonTests];
    addons.push({
      description: selectedItem.name,
      code: selectedItem.code,
      id: selectedItem.id,
    })
    this.setState({
      addonTests: addons
    })
  }

  handleRemoveTest = (id) => {
    let newArray = this.state.addonTests.filter(item => item.id !== id)
    this.setState({
      addonTests: newArray
    })
  }

  fetchTests = async () => {
    this.setState({ loadingTests: true });
    const token = await authService.ensureValidToken();
    if (!token) {
      console.error('Not authenticated');
      return;
    }
    let params = {}
    if (this.state.searchByCodeOrName){
      params.q = this.state.searchByCodeOrName;
    }
    axios({
      method: 'GET',
      url: `${API_BASE_URL}/connect/orderSets/search`,
      params: params,
      headers: { Authorization: `Bearer ${token}` },
    }).then((res) => {
      const options = (res.data.items || []).map(t => ({
        id: t.id,
        code: t.OrderedTest,
        description: `(${t.OrderedTest}) ${t.Description}`,
        name: t.Description,
      }));
      this.setState({
        orderSets: options,
        loadingTests: false,
      });
    })
    .catch((err) => {
      console.log(err);
      this.setState({ loadingTests: false });
    });
  };

  onSubmit = async () => {
    console.log(this.props.addonItem)
    if (this.state.addonTests.length){
      if (this.state.submittedBy){
        this.setState({
          loading: true
        })
        const token = await authService.ensureValidToken();
        if (!token) {
          console.error('Not authenticated');
          return;
        }
        let formData = {};
        formData.tests = this.state.addonTests;
        formData.patientID = this.state.patient.id;
        formData.submittedBy = this.state.submittedBy;
        formData.data = this.props.addonItem;
        formData.date = moment().format('MM/DD/YYYY HH:mm A')
        axios({
          method: 'POST',
          url: `${API_BASE_URL}/connect/orderSets/addons`,
          data: formData,
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob',
        }).then(res => {
          // console.log('status', res.status);
          // console.log('content-type', res.headers['content-type']);
          // console.log('content-disposition', res.headers['content-disposition']);
          // const blob = new Blob([res.data], { type: 'application/pdf' });
          // const pdfUrl = URL.createObjectURL(blob);
          // window.open(pdfUrl);
          // optional cleanup later
          // setTimeout(() => URL.revokeObjectURL(pdfUrl), 60_000);
          toast.success(`Test was successfully added for Accession ${this.state.patient.accession}. Please allow a few minutes for our LIS to process it.`, {
            position: "top-right",
            autoClose: 5000,
          });
          this.setState({
            loading: false,
            orderedTests: [],
            orderSets: [],
            addonTests: [],
            loadingTests: false,
            searchByCodeOrName: "",
            submittedBy: "",
            errors: [],
          }, () => this.props.onClose())
        }).catch(err => {
          console.log(err)
        });
      } else {
        let error = "Please enter your Last Name and First Name";
        this.setState({
          errors: [...this.state.errors, error]
        })
      }      
    } else {
      this.setState({
        loading: false,
        orderedTests: [],
        orderSets: [],
        addonTests: [],
        loadingTests: false,
        searchByCodeOrName: "",
        submittedBy: "",
        errors: [],
      }, () => this.props.onClose())
    }    
  }

  render(){
    return(
      <Drawer
        title='Add Tests'
        size={750}
        onClose={() => this.props.onClose()}
        open={this.state.visible}
      >
        {this.state.loading ?
          <div style={{textAlign:"center"}}>
            <Spin size="large"/>
          </div>
          :
          <Fragment>
            <Row >
              <Col style={{fontSize: '12px'}} xs={24} md={12}>
                <p><span style={{fontWeight: 'bold'}}>AccessionID: </span>{this.state.patient.accession}</p>
                <p><span style={{fontWeight: 'bold'}}>Patient Name: </span>
                  {this.state.patient.patient.lastName},  {this.state.patient.patient.firstName} {this.state.patient.patient.middleName}
                </p>
                <p><span style={{fontWeight: 'bold'}}>DOB: </span>{moment(this.state.patient.patient.dob, 'YYYY-MM-DD').format('MM/DD/YYYY')}</p>
                <p><span style={{fontWeight: 'bold'}}>Collected: </span>{moment(this.state.patient.collectionDate, 'YYYY-MM-DD HH:mm:ss').format('MM/DD/YYYY')}</p>
              </Col>
              <Col style={{fontSize: '12px'}} xs={24} md={12}>
                <label style={{fontWeight: "bold"}}>&nbsp;&nbsp; Received specimens:</label>
                <div style={{overflowY: 'auto', height: '90px'}}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                      {this.state.patient.specimens.map(item =>
                        <tr key={item.code}>
                          <td style={{ padding: '4px 8px' }}>({item.code}) {item.description}</td>
                          <td style={{ padding: '4px 8px' }}>{item.quantity}</td>
                        </tr>
                      )}                    
                    </tbody>
                  </table>
                </div>                
              </Col>
              <Divider/>
              <Col style={{fontSize: '12px'}} xs={24} md={12}>
                <label style={{fontWeight: "bold"}}>&nbsp;&nbsp; Ordered Tests:</label>
                <div style={{overflowY: 'auto', height: '250px'}}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                      {this.state.orderedTests.map(item =>
                        <tr key={item.code}>
                          <td style={{ padding: '4px 8px' }}>{item.code}</td>
                          <td style={{ padding: '4px 8px' }}>{item.name}</td>
                        </tr>
                      )}                    
                    </tbody>
                  </table>
                </div>                
              </Col>
              <Col style={{fontSize: '12px'}} xs={24} md={12}>
                <label style={{fontWeight: "bold"}}>&nbsp;&nbsp; Add Tests:</label>
                <InputWithDropdown
                  listItems={this.state.orderSets}
                  loading={this.state.loadingTests}
                  onSelectItem={(item) => this.onSelectOrderSet(item)}
                  value={this.state.searchByCodeOrName}
                  placeholder="Search Test"
                  onChange={(value) => this.handleTestSearch('searchByCodeOrName', value)}
                />
                <div style={{overflowY: 'auto', height: '240px'}}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                      {this.state.addonTests.map(item =>
                        <tr key={item.id}>
                          <td style={{ padding: '4px 8px' }}>{item.code}</td>
                          <td style={{ padding: '4px 8px' }}>{item.description}</td>
                          <td style={{ padding: '4px 8px' }}>
                            <Button
                              danger
                              size="small"
                              onClick={() => this.handleRemoveTest(item.id)}
                            >
                              <CloseOutlined />
                            </Button>
                          </td>
                        </tr>
                      )}                    
                    </tbody>
                  </table>
                </div>               
              </Col>
              <Divider/>
              <Col style={{fontSize: '12px'}} span={24}>
                <label style={{fontWeight: "bold"}}>Enter you Last Name and First Name:</label>
                <br/><br/>
                <Input 
                  placeholder='Addon form is submitted by'
                  name="submittedBy"
                  value={this.state.submittedBy}
                  onChange={this.handleChange}
                  />
                  <br/><br/>
                  {this.state.errors.length ?
                    <Fragment>
                      <ul style={{listStyle: "none"}}>
                        {
                          this.state.errors.map((message, index) => {
                            return (<li style={{color: 'red', fontSize: "9pt"}} key={index}>{message}</li>)
                          })
                        }
                      </ul>
                    </Fragment>:null
                  }
                  <Button type="primary" onClick={this.onSubmit}>
                    {this.state.loading ?
                      <Spin/> : 'Submit'
                    }
                  </Button>
              </Col>
            </Row>
          </Fragment>
        }
      </Drawer>
    )
  }
}